import './App.css';
import MainArea from './view/landing/MainArea';

function App() {
  return (
    <div className="App">
      <MainArea />
    </div>
  );
}

export default App;
